import { siteInfo } from "@/mocks/gua";

export default function TopStrip() {
  return (
    <div className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2 md:px-6">
        <span className="relative flex h-2.5 w-2.5 shrink-0">
          <span className="live-dot absolute inline-flex h-full w-full rounded-full bg-accent-500" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-accent-500" />
        </span>
        <p className="truncate text-xs text-foreground-700 md:text-sm">
          更新条 · 今日已收录 <span className="font-bold text-foreground-900">{siteInfo.liveCount}</span> 条猛料 · 持续滚动中
        </p>
        <span className="hidden shrink-0 items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs text-accent-700 md:inline-flex">
          <i className="ri-time-line text-sm" />
          {siteInfo.updatedAt} 09:45 更新
        </span>
        <div className="ml-auto hidden shrink-0 items-center gap-3 text-xs text-foreground-600 md:flex">
          <a href="#" className="flex items-center gap-1 whitespace-nowrap hover:text-foreground-900">
            <i className="ri-rss-fill" /> 订阅更新
          </a>
          <a href="#faq" className="whitespace-nowrap hover:text-foreground-900">关于本站</a>
        </div>
      </div>
    </div>
  );
}